import { render, staticRenderFns } from "./TravelCategory.vue?vue&type=template&id=10f01344&"
import script from "./TravelCategory.vue?vue&type=script&lang=js&"
export * from "./TravelCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports